import 'css-chunksrc/client/scenes/comments/feed/reply/styles.scss';export default {
  "reply": "_reply_pmv3f_1",
  "iconBox": "_iconBox_pmv3f_12",
  "icon": "_icon_pmv3f_12",
  "avatar": "_avatar_pmv3f_31",
  "main": "_main_pmv3f_37",
  "header": "_header_pmv3f_41",
  "author": "_author_pmv3f_48",
  "date": "_date_pmv3f_55",
  "content": "_content_pmv3f_61"
};